export default __webpack_public_path__ + "static/media/english-to-tagalog-screenshot-02.458a5514.png";